
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import Title from '../Title/index.vue'
import LazyImg from '@/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import type { AccountGiftUIData } from '@xt/client/entities/my-v2/types.d'
import { EnumProductTypeQuery } from '@xt/client/enums'

@Observer
@Component({
  components: {
    Title,
    LazyImg,
    HeaderImage
  }
})
export default class MyAccount extends Vue {
  accountBackgroundImgList: Array<{
    imgUrl: string
    path: string
  }> = [
    {
      imgUrl: this.$images.my_classroom_order,
      path: '/myv2/account?menu=order'
    },
    {
      imgUrl: this.$images.my_classroom_coupon,
      path: '/myv2/account?menu=packs'
    },
    {
      imgUrl: this.$images.my_classroom_exchange,
      path: '/myv2/account?menu=exchange'
    }
  ]

  get EnumProductTypeQuery() {
    return EnumProductTypeQuery
  }

  get MyClassroomStore() {
    return this.$store.$myV2.Classroom
  }

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  orderGiftHandler(item: AccountGiftUIData) {
    this.UserStore.showOrderGiftsItem(item)
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
